import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import MenuPage from './pages/MenuPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import VendorDashboard from './pages/VendorDashboard';
import RetailDashboard from './pages/RetailDashboard';
import ChefView from './pages/ChefView';
import './App.css';

const RESTAURANT_TYPES = ['restaurant', 'cafe', 'food', 'hotel', 'bar', 'bakery', 'canteen'];
function SmartDashboard() {
  const { business } = useAuth();
  const isRestaurant = RESTAURANT_TYPES.includes((business?.business_type || '').toLowerCase());
  return isRestaurant ? <VendorDashboard /> : <RetailDashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/vendor/login" replace />} />
          <Route path="/vendor/register" element={<RegisterPage />} />
          <Route path="/vendor/login"    element={<LoginPage />} />
          <Route path="/vendor/dashboard" element={
            <ProtectedRoute><SmartDashboard /></ProtectedRoute>
          } />
          <Route path="/vendor" element={<Navigate to="/vendor/dashboard" replace />} />
          <Route path="/shop/:businessId"                element={<MenuPage />} />
          <Route path="/shop/:businessId/order/:orderId" element={<OrderConfirmationPage />} />
          <Route path="/kitchen/:businessId"             element={<ChefView />} />
          <Route path="*" element={<Navigate to="/vendor/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
